import useAuth from 'hooks/useAuth';
import { useDispatch } from 'store';
import { APIUserSlice } from 'store/api/user';
import { errorAlert, successAlert } from 'utils/alert';
import { t } from 'utils/getTranslations';
import { logError } from 'utils/monitoring';

/**
 * Sends a setting change and toasts how it went. A saved change re-reads the session, so what is on for this colleague
 * applies at once; other colleagues get it at their next session read.
 */
export function useSettingSave() {
    const { refreshSessionUser } = useAuth();
    const dispatch = useDispatch();

    return async (change: () => Promise<unknown>): Promise<boolean> => {
        try {
            await change();
        } catch {
            errorAlert(t('back-office-settings.save-error'));
            return false;
        }
        successAlert(t('back-office-settings.saved'));
        dispatch(APIUserSlice.endpoints.getUserData.initiate(undefined, { forceRefetch: true, subscribe: false }))
            .unwrap()
            .then(refreshSessionUser)
            .catch(logError);
        return true;
    };
}
